import { store } from "Store";
import { config } from "Utils/config";
import { http } from "Utils/http";
import { PATHS } from "Utils/PagePaths";
import { getFileDownloadUrl, isPublicPage } from "Utils/utilityFunctions";



var ids = (config.gTagID).split(',');

export const getIds = () => {
    return ids;
}
export const ga_log_content_group = (location) => {

    window.dataLayer = window.dataLayer || [];
    
    window.dataLayer.push({
        //'event': 'page_view',
        'content_group': isPublicPage(location) ? 'public': 'private'
    });

}

export const ga_log_page_view = (location, pageHeader) => {

    window.dataLayer = window.dataLayer || [];
    
    window.dataLayer.push({
        'event': 'page_view',
        'content_group': isPublicPage(location) ? 'public': 'private',
        //'page_header': pageHeader
    });

}

export const ga_log_search = (term) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'search',
        'search_term': term
    });
}
export const ga_log_popup = (variant, popupMsg) => {
    const state = store.getState().errorInfo;

    window.dataLayer = window.dataLayer || [];
    //if(state.popup.visible==true){
        window.dataLayer.push({
            event: "popup",
            popupVariant: variant? variant : "info",
            popupTypeId: state.status.code,
            popupType: state.status.text,
            popupTitle: popupMsg?.title,
            popupMessage: popupMsg?.msg,
            popupShowContact: popupMsg?.showContactHelp
        })
    //}
    
}


export const getDestinationID = () => {
    //console.log(ids);
    return ids[1];
    
}



export const getUserID = () => {
    
    var destId = getDestinationID();
    window.dataLayer = window.dataLayer || [];
    if(window.hasOwnProperty("google_tag_manager") && window.google_tag_manager.hasOwnProperty(destId)){
        var gtm = window.google_tag_manager;
        var userId = (gtm[destId]).dataLayer.get('user_id');
       //console.log("userid: " + userId);
        return userId;
    }
    else{
        return null;
    }
}


export const ga_log_sign_in = () => {
    var loginInfo = store.getState().loginInfo;
    
    window.dataLayer = window.dataLayer || [];
    var x = getLoggedInUserInfo(loginInfo).then((response) => {
        if(response.data!=null){
            var info = response.data;
            var id = getUserID();

            if(id!=null){
                //console.log(id);
                //console.log(info.userId);
                if(id==info.userId){
                    //console.log("already logged in");
                }
                else{
                    //console.log("login");
                    
                    window.dataLayer.push({
                        'event': 'login',
                        'user_id': info.gaUserId,
                        'user_role': info.userRoleId,
                        'org_type_id': info.userOrgTypeId,
                        'pso_id': info.psoId,
                    });
                    
                }
            }
            else{
                window.dataLayer.push({
                    'event': 'login',
                    'user_id': info.gaUserId,
                    'user_role': info.userRoleId,
                    'org_type_id': info.userOrgTypeId,
                    'pso_id': info.psoId
                });
            }

            return response;
        }
        else{
           //console.log("none");
        }
        
    }).catch((error) => {
        //console.log("Error caught while loading data: " + error);
        return error;
    });
    return x;
}

export const synchronousTaskAsync = async (func) => {
    try {
        return Promise.resolve(func());
    } catch (error) {
        return Promise.reject(error);
    }
}


export const getLoggedInUserInfo = async (loginState) => {   
    var url = '/api/ga/userInfo';
    
    //console.log(loginState);
    return http.post(url, null,{ 
        headers: {
            "Authorization": "Bearer " + loginState.token
        }
    });
}

export const ga_log_sign_out = () => {
    //console.log(getUserID());
   var user_id = getUserID();

    if(store.getState().loginInfo?.token.length == 0 && user_id!=null){
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            //'event': 'logout',

            'user_id': null,
            'user_role': null,
            'org_type_id': null,
            'pso_id': null

        });

    }
}

